{
  "common": {
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "info": "Information",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "saved": "Saved",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "back": "Back",
    "next": "Next",
    "done": "Done",
    "yes": "Yes",
    "no": "No",
    "ok": "OK",
    "retry": "Retry",
    "close": "Close",
    "submit": "Submit",
    "update": "Update",
    "remove": "Remove",
    "add": "Add",
    "view": "View",
    "share": "Share",
    "copy": "Copy",
    "copied": "Copied!",
    "noResults": "No results found",
    "pullToRefresh": "Pull to refresh",
    "clearFilters": "Clear all filters",
    "noResultsFilters": "No results match your filters",
    "tryAdjustingFilters": "Try adjusting your search or filters",
    "all": "All",
    "seeMore": "See more",
    "seeLess": "See less"
  },
  "navigation": {
    "myTournaments": "My Tournaments",
    "explore": "Explore Tournaments",
    "friends": "Friends",
    "friendRequests": "Friend Requests",
    "challenges": "Challenges",
    "followers": "Followers",
    "following": "Following",
    "feed": "Feed",
    "settings": "Settings",
    "profile": "Profile",
    "logout": "Logout",
    "searchUsers": "Search Users",
    "leagues": "My Leagues",
    "tournamentsSection": "Tournaments",
    "leaguesSection": "Leagues",
    "exploreLeagues": "Explore Leagues",
    "home": "Home",
    "invitations": "Invitations",
    "joinByCode": "Join by Code",
    "feedback": "Send Feedback",
    "teams": "My Teams",
    "teamsSection": "Teams",
    "exploreTeams": "Explore Teams",
    "createTeam": "Create Team",
    "blog": "Blog",
    "whatsNew": "What's New",
    "trainerPassSection": "TrainerPass",
    "trainerPassLeaderboard": "Leaderboard",
    "myLaunches": "My Launches"
  },
  "auth": {
    "welcomeBack": "Welcome Back",
    "signInToContinue": "Sign in to continue",
    "createAccount": "Create Account",
    "joinTournaly": "Join Tournaly to start competing",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "fullName": "Full Name",
    "signIn": "Sign In",
    "signUp": "Sign Up",
    "signOut": "Sign Out",
    "forgotPassword": "Forgot Password?",
    "resetPassword": "Reset Password",
    "dontHaveAccount": "Don't have an account?",
    "alreadyHaveAccount": "Already have an account?",
    "legalPrefix": "By registering, you agree to our",
    "legalAnd": "and",
    "loginRequired": "Login Required",
    "loginRequiredMessage": "You need to be logged in to perform this action.",
    "login": "Login",
    "enterEmail": "Enter your email",
    "enterPassword": "Enter your password",
    "enterFullName": "Enter your full name",
    "passwordsDontMatch": "Passwords don't match",
    "invalidCredentials": "Invalid credentials",
    "loginFailed": "Login Failed",
    "signUpFailed": "Sign Up Failed",
    "resetPasswordSent": "Password reset email sent",
    "checkEmail": "Check your email for reset instructions",
    "setNewPassword": "Set New Password",
    "enterNewPassword": "Enter your new password below",
    "newPassword": "New Password",
    "confirmNewPassword": "Confirm New Password",
    "updatePassword": "Update Password",
    "passwordUpdated": "Your password has been updated successfully",
    "invalidResetLink": "This reset link is invalid or has expired. Please request a new one.",
    "forgotPasswordSubtitle": "Enter your email to receive a password reset link",
    "sendResetLink": "Send Reset Link",
    "backToLogin": "Back to Login"
  },
  "tournaments": {
    "tournament": "Tournament",
    "tournaments": "Tournaments",
    "createTournament": "Create Tournament",
    "editTournament": "Edit Tournament",
    "deleteTournament": "Delete Tournament",
    "tournamentName": "Tournament Name",
    "description": "Description",
    "rules": "Rules",
    "tournamentRules": "Tournament Rules",
    "tournamentType": "Tournament Type",
    "singleElimination": "Single Elimination",
    "doubleElimination": "Double Elimination",
    "roundRobin": "Round Robin",
    "swiss": "Swiss System",
    "maxParticipants": "Max Participants",
    "startDate": "Start Date",
    "location": "Location",
    "locationOptional": "Location (optional)",
    "public": "Public",
    "private": "Private",
    "publicTournament": "Public Tournament",
    "privateTournament": "Private Tournament",
    "status": "Status",
    "setup": "Setup",
    "inProgress": "In Progress",
    "completed": "Completed",
    "participants": "Participants",
    "participant": "Participant",
    "noParticipantsYet": "No participants yet",
    "addParticipant": "Add Participant",
    "addParticipants": "Add participants to start the tournament",
    "enterParticipantName": "Enter participant name",
    "addRegisteredUser": "Add Registered User",
    "startTournament": "Start Tournament",
    "generating": "Generating...",
    "viewBracket": "View Bracket",
    "bracket": "Bracket",
    "standings": "Standings",
    "admins": "Admins",
    "settings": "Settings",
    "champion": "Champion",
    "winner": "Winner",
    "loser": "Loser",
    "match": "Match",
    "round": "Round",
    "seed": "Seed",
    "score": "Score",
    "vs": "vs",
    "bye": "Bye",
    "tbd": "TBD",
    "invalidParticipantCount": "Invalid participant count. Need power of 2 (2, 4, 8, 16...)",
    "currently": "Currently",
    "tournamentCreated": "Tournament created!",
    "tournamentUpdated": "Tournament updated!",
    "tournamentDeleted": "Tournament deleted!",
    "failedToCreate": "Failed to create tournament",
    "failedToUpdate": "Failed to update tournament",
    "failedToDelete": "Failed to delete tournament",
    "failedToLoad": "Failed to load tournament",
    "tournamentNotFound": "Tournament not found",
    "tournamentPrivate": "This tournament is private",
    "tournamentMayBePrivate": "This tournament may be private or no longer exist",
    "follow": "Follow",
    "following": "Following",
    "unfollow": "Unfollow",
    "followers": "followers",
    "full": "Full",
    "noTournamentsYet": "No tournaments yet",
    "createFirstTournament": "Create your first tournament!",
    "enterName": "Enter name",
    "enterDescription": "Enter description",
    "descriptionOptional": "Description (Optional)",
    "required": "*",
    "singleEliminationDesc": "One loss = out. Fast format.",
    "doubleEliminationDesc": "Two losses = out. Second chance.",
    "roundRobinDesc": "Everyone plays everyone. Points-based.",
    "swissDesc": "Score-based pairing. No elimination.",
    "tripleElimination": "Triple Elimination",
    "tripleEliminationDesc": "3 losses before elimination.",
    "tripleEliminationParticipantsFixed": "Requires exactly 4 participants. The number of participants is fixed for this format.",
    "kingOfTheHill": "King of the Hill",
    "kingOfTheHillDesc": "Defend the throne. Each challenger fights the current king once.",
    "maxParticipantsHint": "Limit the number of players who can join",
    "publicTournamentHint": "Anyone can find and join this tournament",
    "unlimited": "Unlimited",
    "creating": "Creating...",
    "dateTime": "Date & Time",
    "admin": "Admin",
    "viewer": "Viewer",
    "owner": "Owner",
    "yourRole": "Your Role",
    "notSet": "Not set",
    "tapMapToSetLocation": "Tap on the map to set location",
    "saveLocation": "Save Location",
    "editLocation": "Edit Location",
    "addLocation": "Add Location",
    "openInMaps": "Open in Maps",
    "locationPlaceholder": "Location name (e.g., Central Park)",
    "startDateTime": "Start Date & Time",
    "saveDate": "Save Date",
    "editDate": "Edit Date",
    "addDate": "Add Date",
    "publicTournamentDesc": "Anyone with the link can view this tournament",
    "inviteParticipants": "Invite Participants",
    "shareInviteDesc": "Share this link to invite people to join your tournament",
    "shareInviteLink": "Share Invite Link",
    "copyLink": "Copy Link",
    "noRulesYet": "No rules have been set yet",
    "noRulesSubtext": "Add rules to help participants understand the tournament format",
    "rulesPlaceholder": "Enter tournament rules...",
    "saveRules": "Save Rules",
    "editRules": "Edit Rules",
    "addRules": "Add Rules",
    "addAdmin": "Add Admin",
    "noAdminsYet": "No administrators yet",
    "noAdminsSubtext": "Add collaborators to help manage this tournament",
    "onlyOwnerCanManageAdmins": "Only the tournament owner can manage administrators",
    "addAdministrator": "Add Administrator",
    "enterEmailForAdmin": "Enter the email address of the user you want to add as administrator",
    "selectRole": "Select Role",
    "adminRoleDesc": "Can manage participants and update results",
    "viewerRoleDesc": "Can only view tournament (read-only)",
    "enterEmailForParticipant": "Enter the email of a registered user to add them as a participant",
    "searchByNameOrEmail": "Search by name or email to add them as a participant",
    "searchNameOrEmailPlaceholder": "Name or email…",
    "invalidParticipantCountWarning": "⚠️ Invalid participant count. Need power of 2 (2, 4, 8, 16...). Currently: {{count}}",
    "noParticipants": "No participants yet",
    "participantName": "Participant name",
    "enterEmail": "Enter email address",
    "searchByEmail": "Name or email",
    "manual": "Manual",
    "removeParticipant": "Remove Participant",
    "confirmRemoveParticipant": "Are you sure you want to remove this participant?",
    "type": "Type"
  },
  "social": {
    "friends": "Friends",
    "friend": "Friend",
    "addFriend": "Add Friend",
    "removeFriend": "Remove Friend",
    "friendRequest": "Friend Request",
    "friendRequests": "Friend Requests",
    "pendingRequests": "Pending Requests",
    "sendFriendRequest": "Send Friend Request",
    "acceptRequest": "Accept",
    "declineRequest": "Decline",
    "cancelRequest": "Cancel Request",
    "requestSent": "Friend request sent!",
    "requestAccepted": "Friend request accepted!",
    "requestDeclined": "Friend request declined",
    "alreadyFriends": "You are already friends",
    "noFriendsYet": "No friends yet",
    "noRequestsYet": "No friend requests yet",
    "noPendingRequests": "No pending requests",
    "whenReceiveRequestsAppear": "When you receive friend requests, they'll appear here.",
    "requestCount": "{{count}} requests",
    "requestCountSingular": "{{count}} request",
    "followers": "Followers",
    "following": "Following",
    "follow": "Follow",
    "unfollow": "Unfollow",
    "noFollowersYet": "No followers yet",
    "notFollowingAnyone": "Not following anyone yet",
    "challenge": "Challenge",
    "challenges": "Challenges",
    "sendChallenge": "Send Challenge",
    "challengeUser": "Challenge User",
    "addMessage": "Add a message (optional)",
    "challengeSent": "Challenge sent!",
    "challengeAccepted": "Challenge accepted!",
    "challengeDeclined": "Challenge declined",
    "challengeCancelled": "Challenge cancelled",
    "noChallengesYet": "No challenges yet",
    "received": "Received",
    "sent": "Sent",
    "pending": "Pending",
    "accepted": "Accepted",
    "declined": "Declined",
    "accept": "Accept",
    "decline": "Decline",
    "viewTournament": "View Tournament",
    "noChallengesReceived": "No challenges received",
    "noChallengesSent": "No challenges sent",
    "whenChallengedAppear": "When someone challenges you, it will appear here.",
    "haventChallengedAnyone": "You haven't challenged anyone yet.",
    "whenAddFriendsAppear": "When you add friends, they'll appear here."
  },
  "profile": {
    "profile": "Profile",
    "myProfile": "My Profile",
    "editProfile": "Edit Profile",
    "viewProfile": "View Profile",
    "memberSince": "Member since",
    "tournamentsCreated": "Tournaments Created",
    "tournamentsWon": "Tournaments Won",
    "winRate": "Win Rate",
    "matches": "Matches",
    "wins": "Wins",
    "losses": "Losses",
    "posts": "Posts",
    "stats": "Stats",
    "championship": "Championship",
    "championships": "Championships",
    "tournamentHistory": "Tournament History",
    "noTournamentsYet": "No tournaments yet",
    "detailedStatistics": "Detailed Statistics",
    "tournamentsPlayed": "Tournaments Played",
    "totalWins": "Total Wins",
    "totalLosses": "Total Losses",
    "noPostsYet": "No posts yet",
    "requestSent": "Request Sent",
    "acceptRequest": "Accept Request",
    "won": "Won",
    "challengesPlayed": "Challenges Played",
    "challengesWon": "Challenges Won",
    "challengeWins": "Challenge Wins"
  },
  "settings": {
    "settings": "Settings",
    "appearance": "Appearance",
    "darkMode": "Dark Mode",
    "lightMode": "Light Mode",
    "language": "Language",
    "selectLanguage": "Select Language",
    "notifications": "Notifications",
    "pushNotifications": "Push Notifications",
    "pushNotificationsEnabled": "Enabled",
    "pushNotificationsEnable": "Enable",
    "pushNotificationsOpenSettings": "Open Settings",
    "emailNotifications": "Email Notifications",
    "account": "Account",
    "changePassword": "Change Password",
    "deleteAccount": "Delete Account",
    "deleteAccountWarning": "This will permanently delete your account and all your data. This action cannot be undone.",
    "deleteAccountConfirm": "Delete permanently",
    "about": "About",
    "version": "Version",
    "termsOfService": "Terms of Service",
    "privacyPolicy": "Privacy Policy",
    "helpSupport": "Help & Support",
    "contactUs": "Contact Us",
    "rateApp": "Rate App",
    "other": "Other",
    "social": "Social"
  },
  "feed": {
    "feed": "Feed",
    "newPost": "New Post",
    "createPost": "Create Post",
    "whatsOnYourMind": "What's on your mind?",
    "post": "Post",
    "posting": "Posting...",
    "postCreated": "Post created!",
    "failedToPost": "Failed to create post",
    "noPostsYet": "No posts yet",
    "followUsersToSeePosts": "Follow users to see their posts!",
    "deletePost": "Delete Post",
    "deletePostConfirm": "Are you sure you want to delete this post?",
    "linkTournament": "Link Tournament",
    "selectTournament": "Select Tournament",
    "charactersRemaining": "characters remaining",
    "like": "Like",
    "unlike": "Unlike",
    "likes": "likes",
    "oneLike": "like",
    "victoryPost": "I won the tournament \"{{tournamentName}}\"!",
    "sharePost": "Share post",
    "linkCopied": "Link copied to clipboard"
  },
  "post": {
    "screenTitle": "Post",
    "notFound": "This post is not publicly available",
    "notPublicSubtext": "The tournament associated with this post may be private or no longer exist",
    "openInApp": "Open in app",
    "openInAppCta": "View this post in Tournaly",
    "downloadApp": "Download Tournaly",
    "ctaTitle": "Join Tournaly",
    "ctaSubtitle": "Organize tournaments, compete and connect with other players.",
    "ctaSignUp": "Create free account"
  },
  "explore": {
    "explore": "Explore",
    "exploreTournaments": "Explore Tournaments",
    "discover": "Discover",
    "searchPublicTournaments": "Search public tournaments...",
    "discoverTournaments": "Discover Tournaments",
    "noPublicTournaments": "No public tournaments yet",
    "tryDifferentSearch": "Try a different search term",
    "beFirstToCreate": "Be the first to create a public tournament!",
    "loginToSeeFollowed": "Login to see followed tournaments",
    "signInToFollow": "Sign in to follow and track your favorite tournaments",
    "noFollowedTournaments": "No followed tournaments yet",
    "exploreAndFollow": "Explore and follow tournaments to see them here"
  },
  "search": {
    "searchUsers": "Search Users",
    "searchPlaceholder": "Search by name or email...",
    "noUsersFound": "No users found",
    "tryDifferentSearch": "Try searching with a different name or email.",
    "searchForUsers": "Search for users",
    "minCharacters": "Enter at least 2 characters to search for users by name or email."
  },
  "errors": {
    "somethingWentWrong": "Something went wrong",
    "tryAgain": "Please try again",
    "networkError": "Network error. Check your connection.",
    "unauthorized": "You are not authorized to perform this action",
    "notFound": "Not found",
    "serverError": "Server error. Please try again later.",
    "validationError": "Please check your input",
    "requiredField": "This field is required",
    "invalidEmail": "Invalid email address",
    "passwordTooShort": "Password must be at least 6 characters",
    "failedToLoad": "Failed to load data",
    "deleteAccountFailed": "Failed to delete account. Please try again.",
    "rateLimitAuth": "Please wait a moment before trying again.",
    "emailAlreadyRegistered": "This email is already registered. Try logging in instead."
  },
  "alerts": {
    "enterTournamentName": "Please enter a tournament name",
    "mustBeLoggedIn": "You must be logged in to perform this action",
    "cannotEditNotSetup": "Tournament can only be edited while in setup phase",
    "confirmDeleteTournament": "Are you sure you want to delete this tournament? This action cannot be undone.",
    "needMinParticipants": "You need at least 2 participants to start a tournament",
    "confirmStartTournament": "Generate bracket for {{count}} participants? This cannot be undone.",
    "bracketGenerated": "Tournament bracket generated!",
    "failedToGenerateBracket": "Failed to generate bracket",
    "locationUpdated": "Location updated successfully",
    "dateUpdated": "Date updated successfully",
    "rulesUpdated": "Rules updated successfully",
    "userNotFound": "No user found with that email address",
    "userNotFoundRegistered": "No registered user found with that email address",
    "adminAdded": "{{email}} added as administrator",
    "participantAdded": "{{email}} added as participant",
    "adminRemoved": "Administrator removed",
    "cannotAddStarted": "Cannot add participants after tournament has started",
    "cannotDeleteStarted": "Cannot delete participants after tournament has started",
    "confirmDeleteParticipant": "Remove {{name}} from the tournament?",
    "linkCopied": "Invitation link copied to clipboard",
    "tournamentNowPublic": "Tournament is now public. Anyone with the link can view it.",
    "tournamentNowPrivate": "Tournament is now Private. Only you and invited admins can view this tournament.",
    "viewOnly": "You have read-only access to this tournament",
    "matchCompleted": "This match has already been completed.",
    "matchWaiting": "This match is waiting for participants from previous matches.",
    "selectWinner": "Please select a winner",
    "tournamentComplete": "Tournament Complete!",
    "weHaveChampion": "We have a champion!",
    "matchResultUpdated": "Match result updated",
    "exportOptions": "Export bracket as PDF or Image",
    "bracketExported": "Bracket exported successfully",
    "imageSaved": "Bracket saved to your photo library",
    "permissionDenied": "Unable to save to photo library",
    "failedToExport": "Failed to export bracket",
    "useExportPDFOnWeb": "Image export is not available on web. Please use the PDF export option instead.",
    "popupBlocked": "Pop-up was blocked. Please allow pop-ups and try again.",
    "postContentRequired": "Post content is required",
    "maxCharactersExceeded": "Post content must be 500 characters or less",
    "postCreated": "Post created successfully!",
    "postDeleted": "Post deleted successfully",
    "discardPost": "Discard Post?",
    "discardPostConfirm": "Are you sure you want to discard this post?",
    "friendRemoved": "Friend removed successfully",
    "confirmRemoveFriend": "Remove {{name}} from your friends?",
    "friendRequestAccepted": "Friend request accepted",
    "friendRequestDeclined": "Friend request declined",
    "challengeAcceptedTournament": "Challenge accepted! Tournament created.",
    "challengeDeclined": "Challenge declined",
    "followSuccess": "Following successfully",
    "unfollowSuccess": "Unfollowed successfully",
    "requestPending": "Your friend request is pending",
    "alreadyFriends": "You are already friends with this user",
    "challengeSent": "Challenge sent!",
    "enterEmail": "Please enter an email address",
    "enterParticipantName": "Please enter a participant name",
    "fillAllFields": "Please fill in all fields",
    "passwordsNotMatch": "Passwords do not match",
    "passwordMinLength": "Password must be at least 6 characters",
    "enterEmailPassword": "Please enter email and password",
    "registrationFailed": "Registration Failed",
    "checkEmailVerify": "Please check your email to verify your account",
    "photoUploaded": "Photo uploaded successfully. Remember to click Save Changes!",
    "profileUpdated": "Profile updated successfully",
    "discard": "Discard",
    "keep": "Keep Editing",
    "leagueParticipantAdded": "Participant added to league",
    "leagueParticipantRemoved": "Participant removed from league",
    "tournamentCreatedInLeague": "Tournament created and participants added from league"
  },
  "time": {
    "justNow": "Just now",
    "minutesAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago",
    "daysAgo": "{{count}}d ago"
  },
  "filters": {
    "filtersAndSorting": "Filters & Sorting",
    "status": "Status",
    "type": "Type",
    "sortBy": "Sort By",
    "applyFilters": "Apply Filters",
    "newestFirst": "Newest First",
    "oldestFirst": "Oldest First",
    "nameAZ": "Name A-Z",
    "nameZA": "Name Z-A",
    "single": "Single",
    "double": "Double"
  },
  "bracket": {
    "bracket": "Bracket",
    "leaderboard": "Leaderboard",
    "posts": "Posts",
    "noPostsForTournament": "No posts yet",
    "beFirstToPost": "Be the first to share about this tournament!",
    "allRounds": "All Rounds",
    "allMatches": "All Matches",
    "pending": "Pending",
    "upcoming": "Upcoming",
    "completed": "Completed",
    "winnersRound": "W Round",
    "losersRound": "L Round",
    "grandFinal": "Grand Final",
    "grandFinalReset": "Grand Final - Reset",
    "bracketResetNote": "Bracket Reset - Both players have 1 loss",
    "winnersBracket": "Winners Bracket",
    "losersBracket": "Losers Bracket",
    "bracketReset": "Bracket Reset",
    "singleEliminationBracket": "Single Elimination Bracket",
    "doubleEliminationBracket": "Double Elimination Bracket",
    "tripleEliminationBracket": "Triple Elimination Bracket",
    "roundRobinTournament": "Round Robin Tournament",
    "swissSystemTournament": "Swiss System Tournament",
    "kingOfTheHillTournament": "King of the Hill",
    "secondLosersBracket": "Second Chance Bracket",
    "exportOptions": "Export Options",
    "exportOptionsDesc": "Choose how you want to share the tournament",
    "exportPDF": "Export PDF",
    "shareImage": "Share Image",
    "adminCanUpdate": "Admin - Can update results",
    "viewerReadOnly": "Viewer - Read only",
    "standings": "Standings",
    "rankings": "Rankings",
    "finalResults": "Final Results",
    "liveRankings": "Live Rankings",
    "enterMatchResult": "Enter Match Result",
    "pts": "pts",
    "w": "W",
    "l": "L",
    "d": "D",
    "wr": "WR",
    "draw": "Draw",
    "team": "Team",
    "played": "P",
    "won": "W",
    "drawn": "D",
    "lost": "L",
    "goalDifference": "GD",
    "points": "Pts",
    "legendSwiss": "P: Played • W: Won • D: Drawn • L: Lost • Pts: Points",
    "legendRoundRobin": "P: Played • W: Won • D: Drawn • L: Lost • GD: Goal Difference • Pts: Points",
    "match": "Match",
    "round": "Round",
    "selectWinner": "Select Winner:",
    "submitResult": "Submit Result",
    "scoreHint": "Enter scores above. Winner will be determined automatically.",
    "equalScoresDraw": "Equal scores = Draw",
    "score": "Score"
  },
  "editProfile": {
    "changePhoto": "Change Photo",
    "uploadPhoto": "Upload Photo",
    "fullName": "Full Name",
    "enterFullName": "Enter your full name",
    "email": "Email",
    "emailCannotChange": "Email cannot be changed",
    "bio": "Bio",
    "bioPlaceholder": "Tell us about yourself...",
    "saveChanges": "Save Changes",
    "saving": "Saving..."
  },
  "createPost": {
    "photoOptional": "Photo (Optional)",
    "addPhoto": "Add Photo",
    "tournamentOptional": "Tournament (Optional)",
    "none": "None",
    "creatingPost": "Creating Post..."
  },
  "followers": {
    "noFollowersYet": "No followers yet",
    "whenFollowAppear": "When people follow this account, they'll appear here.",
    "follower": "follower",
    "followers": "followers",
    "following": "following"
  },
  "permissions": {
    "permissionRequired": "Permission Required",
    "photoPermission": "We need access to your photos to upload a picture.",
    "failedToPick": "Failed to pick image",
    "failedToUpload": "Failed to upload",
    "photoUploadSuccess": "Photo uploaded successfully!"
  },
  "misc": {
    "unknownUser": "Unknown User"
  },
  "leagues": {
    "league": "League",
    "leagues": "Leagues",
    "createLeague": "Create League",
    "editLeague": "Edit League",
    "deleteLeague": "Delete League",
    "completeLeague": "Complete League",
    "leagueName": "League Name",
    "description": "Description",
    "pointSystem": "Point System",
    "pointSystemDesc": "Points awarded based on final position in each tournament",
    "customPoints": "Custom Points",
    "tournaments": "Tournaments",
    "participants": "Participants",
    "leaderboard": "Leaderboard",
    "settings": "Settings",
    "createTournament": "Create Tournament in League",
    "noLeaguesYet": "No leagues yet",
    "createFirstLeague": "Create your first league to organize a series of tournaments!",
    "noTournamentsInLeague": "No tournaments in this league yet",
    "addTournamentToStart": "Add a tournament to start the league",
    "noStandingsYet": "No standings yet. Complete a tournament to see the leaderboard.",
    "leagueCreated": "League created!",
    "leagueUpdated": "League updated!",
    "leagueDeleted": "League deleted!",
    "leagueCompleted": "League completed!",
    "failedToCreate": "Failed to create league",
    "failedToLoad": "Failed to load league",
    "failedToDelete": "Failed to delete league",
    "confirmDeleteLeague": "Are you sure you want to delete this league? Tournaments will not be deleted but will be unlinked.",
    "confirmCompleteLeague": "Mark this league as completed? All tournaments must be completed first.",
    "notAllTournamentsCompleted": "All tournaments must be completed before the league can be completed.",
    "leagueNotFound": "League not found",
    "totalPoints": "Total Points",
    "position": "Position",
    "pointsAwarded": "Points",
    "setup": "Setup",
    "active": "Active",
    "completed": "Completed",
    "f1Style": "F1 Style (25, 18, 15, 12, 10, 8, 6, 4, 2, 1)",
    "linear": "Linear (10, 8, 6, 5, 4, 3, 2, 1)",
    "winnerTakesAll": "Winner Takes All (3, 1)",
    "custom": "Custom",
    "enterCustomPoints": "Enter points separated by commas (e.g., 10, 7, 5, 3, 1)",
    "participantsLocked": "Participants are locked after the league has started",
    "tournamentsCompleted": "tournaments completed",
    "tournamentsPlayed": "played",
    "nameRequired": "League name is required",
    "invalidPointSystem": "Please enter valid point values separated by commas",
    "champion": "League Champion",
    "visibility": "Visibility",
    "public": "Public",
    "private": "Private",
    "publicDesc": "Anyone can discover and view this league",
    "privateDesc": "Only you can see this league",
    "publicTournamentsWarning": "Making this league public will also make all its tournaments public",
    "exploreLeagues": "Explore Leagues",
    "noPublicLeagues": "No public leagues found",
    "discoverLeagues": "Discover public leagues",
    "logo": "League Logo",
    "uploadLogo": "Upload Logo",
    "changeLogo": "Change Logo",
    "logoOptional": "Optional"
  },
  "status": {
    "challengeStatus": {
      "pending": "Pending",
      "accepted": "Accepted",
      "declined": "Declined"
    },
    "tournamentStatus": {
      "setup": "Setup",
      "in_progress": "In Progress",
      "completed": "Completed"
    }
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark all as read",
    "empty": "No notifications yet",
    "preferences": "Notifications",
    "tournamentStarted": "Tournament Started",
    "tournamentStartedBody": "{{name}} has begun! Check the bracket.",
    "tournamentInvitation": "Tournament Invitation",
    "tournamentInvitationBody": "You've been added to {{name}}.",
    "friendRequest": "Friend Request",
    "friendRequestBody": "{{name}} sent you a friend request.",
    "challengeReceived": "Challenge Received",
    "challengeReceivedBody": "{{name}} has challenged you!",
    "matchResult": "Match Result",
    "matchResultBody": "A match result was updated in {{name}}.",
    "tournamentCompleted": "Tournament Completed",
    "tournamentCompletedBody": "{{name}} has a champion!",
    "leagueInvitation": "League Invitation",
    "leagueInvitationBody": "You've been added to league {{name}}.",
    "type_tournament_started": "Tournament Started",
    "type_tournament_invitation": "Tournament Invitation",
    "type_friend_request": "Friend Request",
    "type_challenge_received": "Challenge Received",
    "type_match_result": "Match Result",
    "type_tournament_completed": "Tournament Completed",
    "type_league_invitation": "League Invitation"
  },
  "moderation": {
    "contentBlocked": "This content doesn't meet our community guidelines. Please revise and try again.",
    "imageBlocked": "This image doesn't meet our community guidelines. Please choose a different image.",
    "cooldownActive": "You're temporarily restricted from posting. Please try again later."
  },
  "invitations": {
    "tournamentInvitations": "Tournament Invitations",
    "inviteByEmail": "Invite by Email",
    "inviteByEmailDesc": "Search for a registered user by email and send them an invitation to join this tournament.",
    "inviteCode": "Invite Code",
    "inviteCodeDesc": "Generate a code that anyone can use to join this tournament.",
    "generateCode": "Generate Code",
    "codeGenerated": "Invite code generated!",
    "joinByCode": "Join by Code",
    "enterCode": "Enter code",
    "enterCodeSubtitle": "Enter the invite code shared by the tournament organizer to join their tournament.",
    "join": "Join",
    "sendInvitation": "Send Invitation",
    "invitationSent": "Invitation sent!",
    "invitationAccepted": "Invitation accepted! You've been added to the tournament.",
    "invitationDeclined": "Invitation declined",
    "invitationCancelled": "Invitation cancelled",
    "alreadyInvited": "This user has already been invited",
    "alreadyParticipant": "This user is already a participant",
    "tournamentNotSetup": "Tournament is no longer accepting participants",
    "tournamentFull": "Tournament is full",
    "invalidCode": "Invalid invite code",
    "codeCopied": "Invite code copied!",
    "optionalMessage": "Add a message (optional)",
    "shareCodeMessage": "Join \"{{name}}\" on Tournaly! Use code: {{code}}",
    "noInvitationsReceived": "No invitations received",
    "noInvitationsSent": "No invitations sent",
    "whenInvitedAppear": "When someone invites you to a tournament, it will appear here.",
    "haventInvitedAnyone": "You haven't invited anyone to a tournament yet.",
    "status": {
      "pending": "Pending",
      "accepted": "Accepted",
      "declined": "Declined",
      "cancelled": "Cancelled"
    }
  },
  "ads": {
    "sponsoredContent": "Sponsored"
  },
  "subscription": {
    "pro": "Pro",
    "free": "Free",
    "unlimited": "Unlimited",
    "upgradeToPro": "Tournaly Pro",
    "manageSubscription": "My Subscription",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "monthlyPrice": "€4.99/month",
    "yearlyPrice": "€39.99/year",
    "yearlyPerMonth": "€3.33/month",
    "yearlySavings": "Save 33%",
    "restorePurchases": "Restore Purchases",
    "subscribe": "Subscribe",
    "choosePlan": "Choose your plan",
    "whatsIncluded": "What's included",
    "paywallSubtitle": "Unlock unlimited tournaments, all formats, and more",
    "youArePro": "You're a Pro!",
    "proDescription": "You have access to all Pro features. Thank you for your support!",
    "renewsOn": "Renews on {{date}}",
    "featureLocked": "Pro Feature",
    "tournamentLimitReached": "You've reached the maximum of 3 active tournaments. Upgrade to Pro for unlimited tournaments.",
    "privateTournamentLimitReached": "Free plan allows 1 private tournament. Upgrade to Pro for unlimited private tournaments.",
    "leagueTournamentLimitReached": "Free plan allows 3 active tournaments per league. Upgrade to Pro for unlimited league tournaments.",
    "planLimitReached": "You've reached a limit of the Free plan. Upgrade to Pro to keep going.",
    "participantLimitReached": "Free plan supports up to 16 participants per tournament.",
    "leagueLimitReached": "You've reached the maximum of 1 active league. Upgrade to Pro for unlimited leagues.",
    "tournamentTypeProOnly": "Double Elimination, Swiss, Triple Elimination, and King of the Hill formats are available with Pro.",
    "pdfExportProOnly": "PDF export is available with Pro.",
    "success": "Success",
    "welcomePro": "Welcome to Tournaly Pro! All features are now unlocked.",
    "error": "Error",
    "noOfferings": "Unable to load subscription options. Please try again later.",
    "purchaseFailed": "Purchase could not be completed. Please try again.",
    "restoreSuccess": "Purchases restored! Your Pro subscription is active.",
    "restoreFailed": "Could not restore purchases. Please try again.",
    "noSubscriptionFound": "No active subscription found for this account.",
    "legalText": "Payment will be charged to your App Store or Google Play account. Subscription automatically renews unless cancelled at least 24 hours before the end of the current period.",
    "webCheckoutRedirect": "You'll be redirected to our secure payment page to complete your subscription.",
    "restoreNotAvailableWeb": "Purchases are managed through your payment provider. If you have an active subscription, it will be reflected here automatically.",
    "proFeatures": {
      "unlimitedTournaments": "Unlimited active tournaments",
      "unlimitedParticipants": "Up to 512 participants per tournament",
      "allFormats": "All tournament formats (incl. Double Elimination, Swiss & Triple Elimination)",
      "unlimitedLeagues": "Unlimited leagues",
      "pdfExport": "PDF bracket export",
      "noWatermark": "No watermark on exports",
      "noAds": "Ad-free experience",
      "proBadge": "Pro badge on your profile"
    },
    "comparison": {
      "title": "Free vs Pro",
      "feature": "Feature",
      "activeTournaments": "Active tournaments",
      "participants": "Participants/tournament",
      "tournamentTypes": "Tournament types",
      "allTypes": "All 6 types",
      "allTypesDetail": "• Single Elimination\n• Double Elimination\n• Triple Elimination\n• Round Robin\n• Swiss\n• King of the Hill",
      "activeLeagues": "Active leagues",
      "privateTournaments": "Private tournaments",
      "pdfExport": "PDF export",
      "watermark": "Watermark",
      "ads": "Ads"
    }
  },
  "feedback": {
    "subtitle": "Your feedback helps us improve Tournaly. Report bugs, suggest features, or share your thoughts.",
    "typeLabel": "Type",
    "type": {
      "bug": "Bug",
      "feature": "Idea",
      "general": "General"
    },
    "messageLabel": "Message",
    "messagePlaceholder": "Describe your feedback in detail...",
    "submit": "Send Feedback",
    "submitting": "Sending...",
    "successTitle": "Thank you!",
    "successMessage": "Your feedback has been received. We read every message."
  },
  "onboarding": {
    "slide1Title": "Create your tournament",
    "slide1Subtitle": "Organize elimination, round robin or Swiss tournaments. You set the format.",
    "slide2Title": "Connect with friends",
    "slide2Subtitle": "Follow friends, challenge them 1v1, and share your victories.",
    "slide3Title": "Teams & leagues",
    "slide3Subtitle": "Create or join a team, compete together in tournaments, and climb the league standings.",
    "next": "Next",
    "skip": "Skip",
    "createTournament": "Create my first tournament",
    "exploreTournaments": "Explore tournaments",
    "notifTitle": "Stay in the loop",
    "notifSubtitle": "Get notified when matches are played, friends challenge you, and your tournaments start.",
    "notifEnable": "Enable notifications",
    "notifLater": "Maybe later"
  },
  "landing": {
    "tagline": "Manage tournaments. Track results. Connect with players.",
    "getStartedFree": "Get Started Free",
    "signIn": "Sign In",
    "downloadApp": "Also available on mobile",
    "downloadOnAppStore": "Download on the App Store",
    "getItOnGooglePlay": "Get it on Google Play",
    "features": {
      "title": "Everything you need to run your tournaments",
      "bracketsTitle": "Bracket Generation",
      "bracketsDesc": "6 formats: Single, Double & Triple Elimination, Round Robin, Swiss, King of the Hill — auto-generated in seconds.",
      "participantsTitle": "Participant Management",
      "participantsDesc": "Add players manually or invite registered users by email or invite code.",
      "standingsTitle": "Live Standings",
      "standingsDesc": "Real-time leaderboards and results updated as matches are played.",
      "socialTitle": "Social Features",
      "socialDesc": "Follow players, send 1v1 challenges, share victory posts and build your community.",
      "leaguesTitle": "Leagues",
      "leaguesDesc": "Create public or private leagues with custom point systems (F1, linear, winner-takes-all…) and track standings across multiple tournaments.",
      "teamsTitle": "Teams",
      "teamsDesc": "Create or join a team with your crew. Invite players, manage your roster, and compete together.",
      "mobileTitle": "Mobile Apps",
      "mobileDesc": "Available on iOS and Android. Manage your tournaments from anywhere.",
      "exportTitle": "Export & Share",
      "exportDesc": "Export brackets as PDF or PNG. Generate QR codes and shareable links for any tournament. Send invites by email in one tap.",
      "inviteTitle": "Invite Codes",
      "inviteDesc": "Share a unique 8-character code — players join instantly without needing to create an account first.",
      "exploreTitle": "Explore & Discover",
      "exploreDesc": "Browse public tournaments and leagues. Follow tournaments to get notified of every result."
    },
    "screenshots": {
      "title": "See it in action",
      "tournamentList": "Tournament List",
      "bracketView": "Bracket View",
      "leaderboard": "Leaderboard",
      "tournamentListTitle": "All your tournaments",
      "tournamentListDesc": "Manage and track every active tournament from one clean overview.",
      "bracketViewTitle": "Live bracket",
      "bracketViewDesc": "Watch the bracket evolve in real-time as each match is played.",
      "leaderboardTitle": "Live standings",
      "leaderboardDesc": "Automatic leaderboard updated instantly with every result.",
      "socialSubtitle": "Built for competitors who play together",
      "challenges": "Challenges",
      "challengesTitle": "1v1 Challenges",
      "challengesDesc": "Challenge any friend to a head-to-head tournament. Accept, compete, and settle the score.",
      "friends": "Friends",
      "friendsTitle": "Friends & followers",
      "friendsDesc": "Build your circle, follow players, and stay connected through every competition.",
      "feed": "Feed",
      "feedTitle": "Social feed",
      "feedDesc": "Catch up on results, victory posts, and highlights from everyone you follow."
    },
    "heroTitle": "The tournament manager",
    "heroTitleAccent": "built for everyone",
    "pricing": {
      "title": "Simple, transparent pricing",
      "forever": "Forever"
    },
    "footer": {
      "cta": "Ready to start your first tournament?",
      "privacy": "Privacy Policy",
      "terms": "Terms of Service",
      "copyright": "All rights reserved."
    }
  },
  "welcome": {
    "headline": "The tournament manager\nbuilt for everyone",
    "feature1": "6 bracket formats: SE, DE, Triple Elim, Round Robin, Swiss, King of the Hill",
    "feature2": "Teams, leagues, standings & leaderboards",
    "feature3": "Challenge friends & share results",
    "getStarted": "Get Started — Free",
    "alreadyHaveAccount": "Already have an account?",
    "signIn": "Sign In"
  },
  "home": {
    "welcomeBack": "Welcome back, {{name}}!",
    "pendingActions": "Pending Actions",
    "tournamentInvitationsPending": "{{count}} tournament invitation(s) pending",
    "teamInvitationsPending": "{{count}} team invitation(s) pending",
    "friendRequestsPending": "{{count}} friend request(s) pending",
    "challengesPending": "{{count}} challenge(s) waiting",
    "activeTournaments": "Active Tournaments",
    "myLeagues": "My Leagues",
    "recentActivity": "Recent Activity",
    "discover": "Discover Tournaments",
    "seeAll": "See all",
    "explore": "Explore",
    "noActiveTournaments": "No active tournaments",
    "noPublicTournaments": "No public tournaments yet",
    "createTournament": "New Tournament",
    "createLeague": "New League",
    "gettingStartedTitle": "Get started with Tournaly",
    "gettingStartedStep1": "Create your first tournament",
    "gettingStartedStep2": "Explore public tournaments",
    "gettingStartedStep3": "Create a league"
  },
  "teams": {
    "team": "Team",
    "teams": "Teams",
    "myTeams": "My Teams",
    "createTeam": "Create Team",
    "editTeam": "Edit Team",
    "exploreTeams": "Explore Teams",
    "discoverTeams": "Search teams by name...",
    "teamName": "Team Name",
    "teamNamePlaceholder": "Enter team name",
    "description": "Description",
    "descriptionPlaceholder": "Describe your team (optional)",
    "members": "Members",
    "addMember": "Invite Member",
    "pendingInvitations": "Pending Invitations",
    "pendingInvitation": "Pending invitation",
    "removeMember": "Remove Member",
    "leaveTeam": "Leave Team",
    "deleteTeam": "Delete Team",
    "public": "Public",
    "private": "Private",
    "publicDesc": "Anyone can discover and view this team",
    "visibility": "Visibility",
    "captain": "Captain",
    "member": "Member",
    "noTeams": "No teams yet",
    "noTeamsDesc": "Create your first team or wait to be invited",
    "noPublicTeams": "No public teams found",
    "noPublicTeamsDesc": "Be the first to create a public team",
    "noMembers": "No members yet",
    "noMembersDesc": "Invite players to join your team",
    "invitePlayer": "Invite player by email",
    "invitationSent": "Invitation sent",
    "memberAdded": "Member added successfully",
    "memberRemoved": "Member removed",
    "leftTeam": "You have left the team",
    "teamDeleted": "Team deleted",
    "confirmLeave": "Are you sure you want to leave this team?",
    "confirmDelete": "Are you sure you want to delete this team? This action cannot be undone.",
    "confirmRemove": "Are you sure you want to remove this member?",
    "captainCannotLeave": "You are the team captain. Delete the team instead.",
    "uploadLogo": "Upload Logo",
    "changeLogo": "Change Logo",
    "save": "Save Changes",
    "settings": "Settings",
    "teamInvitationTitle": "Team Invitations",
    "invitedToJoin": "You have been invited to join {{teamName}}",
    "invitePending": "Pending invitation to {{teamName}}",
    "memberCount": "{{count}} member",
    "memberCount_plural": "{{count}} members",
    "teamSection": "Teams"
  },
  "deleteAccountPage": {
    "title": "Delete Your Account",
    "intro": "Deleting your account will permanently remove all your data from Tournaly, including your profile, tournaments, matches, posts, and social connections.",
    "warning": "This action is irreversible. Once deleted, your data cannot be recovered.",
    "bullet1": "Your profile and personal information",
    "bullet2": "All tournaments you created or participated in",
    "bullet3": "Your posts and social activity",
    "bullet4": "All match results and standings",
    "signInToDelete": "Sign in with your account credentials to proceed with deletion.",
    "signedInAs": "Signed in as",
    "signInAndDelete": "Sign In to Delete Account",
    "successTitle": "Account Deleted",
    "successMessage": "Your account and all associated data have been permanently deleted.",
    "backToApp": "Return to Tournaly"
  },
  "blog": {
    "title": "Blog",
    "subtitle": "News, updates, and guides from the Tournaly team",
    "readMore": "Read more →",
    "backToBlog": "← Back to Blog",
    "latestUpdates": "What's New",
    "viewAllPosts": "View all posts →",
    "publishedOn": "Published on {{date}}"
  },
  "training": {
    "title": "TrainerPass",
    "bestRpm": "Best RPM",
    "totalLaunches": "Launches",
    "avgConsistency": "Avg Consistency",
    "avgScore": "Avg Score",
    "bestSpeed": "Top Speed",
    "leaderboardTitle": "Leaderboard",
    "leaderboardEmpty": "No launches synced yet. Connect TrainerPass to appear here!",
    "launchMeta": "{{launches}} launches · {{consistency}}% consistency",
    "tabScore": "Score",
    "tabRpm": "RPM",
    "tabConsistency": "Consistency",
    "tabLaunches": "Launches",
    "myLaunchesTitle": "My Launches",
    "myLaunchesEmpty": "No launches yet. Sync your TrainerPass to see them here.",
    "launchDate": "{{date}}",
    "rpm": "RPM",
    "score": "Score",
    "consistency": "Consistency",
    "duration": "Duration",
    "seconds": "{{s}}s"
  }
}
